<template>
  <input type="text">
</template>

<script>
export default {
  name: 'EditableTextInput'
}
</script>